<template>
<el-row type="flex" justify="center">
  <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" class="header" :style="{'margin-left':isMobile ? '2em':'0em'}">
    <add-dialog v-if="showAddDialog" :SHOW.sync="showAddDialog"></add-dialog>
    <!-- <div class="headLeft"> -->
    <img data-aos="flip-up" src="@/assets/img/home/logo.png" />
    <!-- </div> -->
    <div data-aos="zoom-in" v-show="!isMobile" class="headRight">
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        active-text-color="#5772FE"
        text-color="black"
        :popper-append-to-body="true"
        class="nav"
      >
        <el-menu-item index="homepage">首页</el-menu-item>
        <el-submenu index="">
          <template slot="title" style="color:black;">产品</template>
          <el-menu-item v-for="(item,key) in productMenu " :key="key" :index="String(item.index)">
            <span class="iconfont" :class="item.iconClass"></span>
            <div class="menuItem">
              <span class="title">{{item.title}}</span>
              <span class="text">{{item.text}}</span>
            </div>
          </el-menu-item>
          <!-- <div class="line"></div> -->
        </el-submenu>
        <el-menu-item index="solution">解决方案</el-menu-item>
        <el-menu-item index="introduce">关于望潮</el-menu-item>
        <el-menu-item index="register">
          <el-button type="primary" class="registerBtn">免费注册</el-button>
        </el-menu-item>
      </el-menu>
    </div>
    <div v-show="isMobile" class="mobileRight iconfont icon-caidan1" @click.self="switchVerticalMenu">
      <el-collapse-transition>
      <div v-show="showMobileMenu" class="mobileMenu" :style="{'width':menuWidth+'px','height':menuHeight+'px'}">
        <el-menu
          :default-active="activeIndex"
          mode="vertical"
          @select="handleSelect"
          active-text-color="#5772FE"
          text-color="black"
          :popper-append-to-body="true"
          class="nav"
        >
          <el-menu-item index="homepage"><i class="iconfont icon-zhuye"></i>首页</el-menu-item>
          <el-submenu index="">
            <template slot="title" style="color:black;"><i class="iconfont icon-chanpin"></i>产品</template>
            <el-menu-item v-for="(item,key) in productMenu " :key="key" :index="String(item.index)">
              <i class="iconfont" :class="item.iconClass"></i>
              <span>{{item.title}}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="solution"><i class="iconfont icon-jiejuefanganchi"></i>解决方案</el-menu-item>
          <el-menu-item index="introduce"><i class="iconfont icon-guanyu"></i>关于望潮</el-menu-item>
          <el-menu-item index="register">
            <i class="iconfont icon-zhuce"></i>免费注册
          </el-menu-item>
        </el-menu>
      </div>
      </el-collapse-transition>
    </div>
    
  </el-col>
</el-row>
</template>

<script>
import AddDialog from "@/components/Dialog.vue";
import ResizeEvent from "@/components/resizeEvent"
export default {
  name: "myHeader",
  components: {
    AddDialog
  },
  mixins:[ResizeEvent],
  data() {
    return {
      showAddDialog: false,
      activeIndex: this.$route.name,
      showMobileMenu:false,
      productMenu: [
        // {
        //   index: "service",
        //   iconClass: "icon-webicon302",
        //   title: "慧声客服",
        //   text: "告别等待,一站式优化服务"
        // },
        {
          index: "call",
          iconClass: "icon-dianhua",
          title: "慧声外呼",
          text: "真人语音,告别人工时代"
        },
        // {
        //   index: "quality",
        //   iconClass: "icon-icon_anquan",
        //   title: "慧质智检",
        //   text: "节约人工,增加质检"
        // },
        // {
        //   index: "assitant",
        //   iconClass: "icon-caidan",
        //   title: "慧秘辅助",
        //   text: "人机协作,提升客服效率"
        // }
      ],
      menuWidth:300,
      menuHeight:document.body.offsetHeight,
    };
  },
  mounted(){
    console.log(this.menuHeight);
    // this.menuHeight = document.body.scrollHeight;
    document.addEventListener("click", this.closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeMenu);
  },
  methods: {
    handleSelect(index) {
      if (index === "register") {
        // this.$message({
        //   message: "功能未开放，敬请期待",
        //   type: "warning",
        //   duration: 2000
        // });
        this.showAddDialog = true;
      } else{ 
        this.$router.push({ name: index });
        if(index){
          this.showMobileMenu = false;
        }
      }
    },
    switchVerticalMenu(){
      this.showMobileMenu=!this.showMobileMenu;
    },
    closeMenu(event){
      let target = event.target;
      let classList = ['el-submenu','mobileRight'];
      this.showMobileMenu = classList.some(item=>{return target.className.includes(item)});
    }
  },
  watch: {
    "$route.name": {
      handler(newVal) {
        this.activeIndex = newVal;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.header {
  height: 60px;
  // width: 60rem;
  
  background: rgba(255, 255, 255, 1);
  color: #000000;
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  align-items: center;
  // .headLeft {
    // height: 60px;
    img {
      height: 1.75rem;
    }
  // }

  .headRight {
    height: 60px;
    margin-left: 10px;
    .nav {
      border: 0px;
    }
    ul > li {
      font-weight: bold;
      border: none;
      font-size: 16px;
    }
  }
  .mobileRight{
    margin-right: 2em;
    position: relative;
    color: #1191fd;
    .mobileMenu {
      position: absolute;
      z-index: 100;
      right: -2em;
      top: 2em;
      .el-menu{
        height: 100%;
        overflow: hidden;
      }
    }
  }
  .el-menu-item,.el-submenu__title{
    i{
      margin-right: 1em;
    }
  }
  .registerBtn {
    background-color: #ccc !important;
    border: none;
    font-size: 16px;
    padding: 12px 20px;
  }
  
}
.line {
  position: absolute;
  height: 155px;
  width: 1px;
  border-right: 1px solid #eeeeee;
  left: 269px;
  top: 20px;
}
.el-menu--horizontal {
  position: relative;
}
// 二级菜单栏样式
.el-menu--horizontal .el-menu {
  border-top: 1px solid white;
  display: flex;
  background-color: #fff;
  .el-menu-item:hover {
    background-color: #f5f5f5;
  }
  .el-menu-item:link {
    background-color: #f5f5f5;
  }
  .el-menu-item {
    display: inline-block;
    box-sizing: border-box;

    width: 250px;
    height: 75px;
    margin: 5px 10px;
    padding: 5px 9px;

    .iconfont {
      display: inline-block;
      width: 40px;
      height: 40px;
      border: 1px solid;
      border-radius: 50%;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      line-height: 40px;
      // vertical-align: center;
    }

    .menuItem {
      display: inline-block;
      margin-left: 10px;
      // color: black;
      span {
        display: block;
        width: 180px;
        height: 18px;
      }
      .title {
        margin-bottom: 10px;
        font-size: 18px;
      }
      .text {
        font-size: 12px;
        margin-bottom: 10px;
      }
    }
  }

  & li:nth-child(1) {
    .iconfont {
      color: #06a141;
      border-color: #009f3c;
    }
  }
  & li:nth-child(2) {
    .iconfont {
      color: #007bff;
      border-color: #007bff;
      font-size: 20px;
    }
  }
  & li:nth-child(3) {
    .iconfont {
      color: #e16cf5;
      border-color: #e16cf5;
      font-size: 25px;
    }
  }
  & li:nth-child(4) {
    .iconfont {
      color: #dc3545;
      border-color: #dc3545;
      font-size: 20px;
    }
  }
}
.el-menu-item:hover {
  color: #5772fe !important;
}
</style>
<style lang="scss">
.el-menu--horizontal {
  ul {
    display: block;
    margin: 0px;
    width: 270px;
    height: 90px;
    background-color: #fff;
    transform: translateX(-40%);
    // margin-right: 22rem;
  }
  .el-submenu__title:hover {
    color: #5772fe !important;
  }
  .el-submenu__title:link {
    color: #5772fe !important;
  }
  .el-submenu__title {
    font-weight: bold;
    font-size: 16px;
    border: none !important;
    // color: black !important;
  }
}
</style>